import React from 'react'
import classes from './Toast.module.scss'
import Typography from '@/components/ui/Typography'
import { useTranslation } from 'react-i18next'

export type ToastProps = {
  title: string
  caption?: string
}

const Toast = ({ title, caption }: ToastProps) => {
  const { t } = useTranslation()

  return (
    <div className={classes.root}>
      <Typography>{t(title)}</Typography>
      {caption && <Typography variant={'caption'}>{t(caption)}</Typography>}
    </div>
  )
}

export default Toast
